import { SetPaginationPayload } from '../actions/pagination';
import {ApiQueryData, ProductVariantActionState} from '../interfaces';
import { PARAM_PAGE } from '../constants';

export const doSetPagination = (state: ProductVariantActionState, payload: SetPaginationPayload): ProductVariantActionState => {
    const newApiQueryData: ApiQueryData = {
        ...state.apiQueryData,
        [PARAM_PAGE]: payload[PARAM_PAGE],
    };

    return {
        ...state,
        apiQueryData: newApiQueryData,
    };
};
